var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 226,
    viewBox: "0 0 75.935415 59.795835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25791",
    transform: "matrix(1.0046293,0,0,1.0018025,-52.930503,-27.308885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 121.69169,69.417638 c 0.4149,-0.173678 0.89074,-0.08254 1.32945,-0.06605 0.64353,0.02419 2.26617,0.664538 1.93066,0.116245 -0.20944,-0.342266 -0.34535,-0.803548 -0.42168,-1.224885 -0.18351,-1.012962 -0.53162,-2.153277 -0.0782,-3.086678 0.22036,-0.45365 0.66437,-0.783523 1.01865,-1.14578 0.54318,-0.555409 1.29727,-0.785474 2.04336,-0.977772 0.27501,-0.07088 0.51187,0.0922 0.44449,-0.371865 -0.11369,-0.782951 -0.15092,-1.572543 -0.24172,-2.359371 -0.23769,-2.059601 0.14072,-4.118911 0.14554,-6.179771 0.003,-1.107307 0.37864,-2.47498 -0.37799,-3.310607 -0.30004,-0.331364 -0.79662,-0.417275 -1.21138,-0.56343 -0.82571,-0.290967 -1.70028,-0.490874 -2.40302,-1.055023 -0.58443,-0.469174 -1.28156,-0.893179 -1.61774,-1.56069 -0.41213,-0.818309 -0.79202,-1.746139 -0.66028,-2.641485 0.0846,-0.575125 -0.43066,-0.448852 -0.81911,-0.438041 -1.4497,0.04035 -2.89653,0.158083 -4.34936,0.09315 -2.94743,-0.131725 -5.88801,-0.432033 -8.8442,-0.374444 -4.77278,0.09298 -9.539959,0.364732 -14.310428,0.541942 -0.322553,0.01198 -0.526707,0.139069 -0.692113,-0.270372 -0.493159,-1.220751 -1.35056,-2.249565 -1.829796,-3.485908 -0.16736,-0.431759 0.136596,-0.844079 0.522214,-1.028362 0.969397,-0.463266 2.102077,-0.427969 3.136069,-0.239545 0.477414,0.087 0.896526,0.321995 1.275565,0.643186 0.338762,0.287061 1.026101,1.327195 1.00262,0.892593 -0.02355,-0.435887 -0.09455,-0.912283 0.04584,-1.335744 0.211114,-0.636773 0.352286,-1.313729 0.794343,-1.848426 0.345818,-0.41829 0.659844,-0.920755 1.146616,-1.155007 0.519389,-0.249949 -0.263861,-0.250654 -0.493273,-0.434492 -0.708229,-0.567536 -1.178548,-1.331216 -1.709894,-2.099543 -0.185221,-0.26783 -0.419634,-1.2614 -0.55486,-1.005855 -0.22456,0.424364 -0.411916,0.854305 -0.70526,1.249705 -0.41568,0.560297 -1.035017,0.943353 -1.739339,1.072791 -0.874825,0.160772 -1.737236,0.449623 -2.644757,0.41474 -0.555527,-0.02135 -0.629926,-0.480161 -0.542331,-0.99466 0.189274,-1.111725 0.821492,-2.067932 1.546771,-2.931492 0.288982,-0.344079 1.304041,-0.985774 1.013429,-1.013736 -1.062653,-0.102245 -2.256126,-0.203163 -3.026372,-1.023379 -0.642816,-0.684519 -0.869565,-3.372584 -1.325466,-2.481163 -0.454112,0.887923 -0.510512,2.041494 -1.293412,2.708429 -0.655086,0.558053 -1.574236,0.579859 -2.311374,0.968976 -0.236821,0.125012 -0.99715,0.479509 -0.819804,0.528867 0.503142,0.140031 0.927589,0.474107 1.347701,0.772623 1.167438,0.829536 1.966216,2.101558 2.310767,3.485555 0.08525,0.342425 0.321569,0.672147 -0.246034,0.732582 -1.920902,0.204525 -3.867454,-0.696716 -5.068381,-2.268096 -0.196293,-0.256844 -0.458375,-1.088679 -0.474462,-0.933405 -0.0775,0.74803 -0.128715,1.524506 -0.538353,2.198081 -0.633923,1.042371 -1.638833,1.755375 -2.656655,2.436218 -0.228254,0.152684 -0.951121,0.449977 -0.830551,0.46902 0.86253,0.136229 1.709911,0.503266 2.333278,1.094399 0.88508,0.839313 1.727062,1.801366 2.149451,2.940713 0.141456,0.381562 0.222171,-0.347735 0.274234,-0.521578 0.216937,-0.724377 0.705133,-1.35363 1.38885,-1.71002 1.03021,-0.537 2.220604,-0.68134 3.396072,-0.639902 0.6936,0.02445 0.335376,0.851821 0.269967,1.285043 -0.129848,0.860018 -0.213036,1.788415 -0.717008,2.518133 -0.519304,0.751918 -1.479623,0.959202 -2.318195,1.109466 -2.122148,0.380269 -4.2952,0.09188 -6.423786,0.419874 -1.502211,0.231473 -3.025774,0.182282 -4.537454,0.08219 -2.5497,-0.168814 -5.104726,-0.300897 -7.659334,-0.286013 -1.471267,0.0086 -2.939862,-0.01926 -4.411362,-0.124299 -1.538001,-0.109784 -3.089931,0.05206 -4.62855,-0.112481 -0.560315,-0.05992 -0.367174,0.557769 -0.434307,0.925018 -0.204122,1.116645 -0.669268,2.26691 -1.547656,2.976452 -0.571697,0.461804 -1.649305,0.397762 -1.892193,1.094795 -0.198602,0.569943 -0.169922,1.214714 -0.144861,1.816115 0.07563,1.814925 0.45386,3.604022 0.440325,5.427085 -0.01915,2.580051 0.102797,5.158768 0.0923,7.740092 -0.0036,0.878539 -0.906344,2.620907 -0.0076,2.639328 0.478719,0.0098 0.968825,0.121295 1.389182,0.34093 1.077782,0.563138 1.885048,1.539328 2.468431,2.590347 0.219096,0.394722 0.390406,0.783648 0.994591,0.707847 0.516899,-0.06485 1.04082,-0.02644 1.557836,-0.08304"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g25678",
    style: {
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 59.116703,47.147698 c 0.06622,1.351198 0.132232,2.703433 0.120474,4.056785 -0.0037,0.42024 -0.03108,0.839748 -0.03336,1.260069 -0.0076,1.403322 0.02822,2.806429 0.03497,4.209683 0.0026,0.53864 0.009,1.077619 -0.01006,1.616043",
    id: "path2532"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 65.660743,47.197848 c 0.04344,2.542488 0.296401,5.078591 0.277254,7.622291 -0.0055,0.735084 -0.02441,1.469991 -0.03376,2.205032 -0.0018,0.14293 -0.0037,0.285864 -0.0038,0.428807",
    id: "path2536"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 59.372153,54.035008 c 0.509413,-0.04353 1.002339,-0.196374 1.477752,-0.377468 1.149979,-0.43805 2.225748,-1.046109 3.367724,-1.502515 0.455033,-0.18186 0.921387,-0.351529 1.409047,-0.417508 0.112493,-0.01522 0.225926,-0.02433 0.339487,-0.02435",
    id: "path2540"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 72.188683,54.963738 c -0.138656,-0.471553 -0.186989,-0.962616 -0.230108,-1.450352 -0.04123,-0.466368 -0.104764,-0.934959 -0.262646,-1.378769 -0.06154,-0.172993 -0.146335,-0.33604 -0.22771,-0.500234 -0.08027,-0.161962 -0.121653,-0.344378 -0.230713,-0.490988 -0.105369,-0.141648 -0.273349,-0.224306 -0.441927,-0.261436 -0.231776,-0.05105 -0.470821,0.01873 -0.677051,0.124559 -0.248319,0.127427 -0.473753,0.299444 -0.657115,0.510672 -0.361327,0.41624 -0.601605,0.924039 -0.770678,1.444575 -0.229798,0.707495 -0.35213,1.453087 -0.335611,2.196959 0.01048,0.471779 0.05591,0.95666 0.250043,1.390522 0.12829,0.286715 0.292993,0.561543 0.512551,0.787368 0.09036,0.09294 0.181873,0.188953 0.293682,0.254915 0.154183,0.09096 0.342318,0.09357 0.514489,0.07082 0.20709,-0.02737 0.411907,-0.07679 0.607444,-0.150274 0.364661,-0.13705 0.680645,-0.39193 0.900127,-0.713378 0.289318,-0.423727 0.428611,-0.928829 0.512781,-1.429335 0.126234,-0.750632 0.132726,-1.513609 0.211983,-2.269426 0.03841,-0.366328 0.0631,-0.735913 0.02826,-1.104247 -0.0069,-0.07289 0.03691,-0.1796 -0.02605,-0.219143 -0.05359,-0.03366 -0.05487,0.07358 -0.0562,0.108452 -0.0068,0.177574 0.0222,0.354284 0.02254,0.531539 0.0012,0.643004 0.01315,1.293432 0.160295,1.921643 0.06064,0.258907 0.210909,0.492575 0.243099,0.757463 0.05403,0.4446 0.157474,0.892194 0.380341,1.284729 0.117097,0.206243 0.290939,0.370209 0.458915,0.538092 0.172285,0.17219 0.354893,0.334258 0.549401,0.481006",
    id: "path2544"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 74.231893,51.001138 c 0.800749,-0.155724 1.59915,-0.330081 2.408318,-0.435147 0.190421,-0.02472 0.383229,-0.02754 0.574036,-0.05351 0.05166,-0.007 0.09091,0.01533 0.07461,0.0795 -0.07499,0.295283 -0.170416,0.584952 -0.262551,0.8752 -0.376948,1.187482 -0.801073,2.360635 -1.138855,3.559899 -0.05909,0.209804 -0.130572,0.415795 -0.210051,0.618771 -0.154078,0.393489 -0.361982,0.78139 -0.392942,1.206317 -0.0036,0.04978 -0.04331,0.14803 0.0092,0.151641 0.06038,0.0042 0.122608,-0.03568 0.178429,-0.06132 0.37817,-0.173683 0.702692,-0.446821 1.081733,-0.616614 1.006811,-0.451006 2.024831,-0.87624 3.03843,-1.311626 0.523101,-0.224695 1.046676,-0.451903 1.54332,-0.731584",
    id: "path2548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 79.308973,51.186888 c 0.526883,-0.348448 1.095405,-0.631269 1.685407,-0.856105 0.67444,-0.257014 2.140215,-1.377652 2.060483,-0.660825 -0.10763,0.967644 -0.273671,1.929261 -0.513605,2.873201 -0.282383,1.11094 -0.544412,2.237652 -1.003325,3.287399 -0.139499,0.319099 -0.293432,0.639318 -0.350272,0.984513 -0.0187,0.113555 -0.05056,0.243705 0.0097,0.346667 0.03814,0.06513 0.113327,-0.0045 0.15032,-0.03606 0.05623,-0.04791 0.114594,-0.09239 0.178899,-0.130343 1.272515,-0.750948 2.535687,-1.525742 3.877144,-2.149616 0.425833,-0.198043 0.859534,-0.380245 1.304117,-0.532089",
    id: "path2552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 90.113243,50.939228 c -0.260791,-0.351383 -0.514888,-0.71151 -0.825016,-1.021801 -0.189308,-0.189407 -0.415885,-0.360889 -0.685206,-0.410753 -0.288703,-0.05345 -0.580875,0.02296 -0.856342,0.106098 -0.170117,0.05134 -0.337692,0.115571 -0.486846,0.214208 -0.283193,0.187277 -0.543521,0.446349 -0.64482,0.771708 -0.185028,0.594286 -0.27873,1.21443 -0.316198,1.834366 -0.04236,0.700941 -0.03188,1.414369 0.13505,2.099042 0.09712,0.398337 0.245688,0.799552 0.524953,1.108337 0.195471,0.216134 0.475118,0.353889 0.76744,0.368344 0.382358,0.01891 0.752873,-0.121496 1.08319,-0.302513 0.371262,-0.203456 0.688556,-0.508475 0.890426,-0.882675 0.240162,-0.445182 0.318448,-0.954456 0.360933,-1.452475 0.03539,-0.414793 0.04683,-0.831011 0.0854,-1.245758 0.02891,-0.31087 0.07024,-0.625423 0.03046,-0.936439 -0.0112,-0.08754 2.93e-4,-0.314172 -0.06762,-0.2563 -0.03091,0.02634 -0.02278,0.09369 -0.02564,0.137714 -0.05589,0.860189 0.04841,1.725624 0.254371,2.560062 0.09222,0.3736 0.15978,0.752751 0.250387,1.126765 0.123224,0.508655 0.251835,1.02286 0.486658,1.492585 0.110758,0.221553 0.241437,0.445611 0.44482,0.595039 0.109412,0.08039 0.248616,0.112206 0.383429,0.09526 0.270817,-0.03404 0.515454,-0.16703 0.749941,-0.298493 0.133415,-0.0748 0.264507,-0.153954 0.401172,-0.2228",
    id: "path2556"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 95.097453,45.645438 c 0.280016,1.506687 0.375047,3.038918 0.487422,4.564915 0.08783,1.192747 0.16252,2.390118 0.373351,3.568777 0.105965,0.5924 0.243967,1.182778 0.470407,1.741848",
    id: "path2560"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 91.382513,50.629648 c 0.840683,0.181929 1.691729,0.319073 2.548071,0.398922 0.594732,0.05545 1.193803,0.08956 1.79105,0.05004 0.326143,-0.02159 0.652703,-0.03889 0.978476,-0.06751 1.280678,-0.112506 2.545553,-0.370083 3.78021,-0.725788 0.88843,-0.255957 1.76284,-0.557526 2.63519,-0.863013",
    id: "path2568"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 100.49883,54.815158 c -0.0365,0.03914 -0.0477,0.09419 -0.0534,0.145492 -0.0132,0.118785 -0.005,0.23871 0.007,0.357199 0.009,0.09337 0.018,0.190346 0.0636,0.274389 0.0211,0.03889 0.0563,0.07845 0.10365,0.07937 0.0502,9.76e-4 0.093,-0.03177 0.12654,-0.06583 0.0465,-0.04725 0.0841,-0.102171 0.12369,-0.155085 0.0388,-0.05188 0.083,-0.100032 0.11746,-0.154954 0.0269,-0.04289 0.0499,-0.08838 0.067,-0.135935 0.0134,-0.03752 0.0432,-0.07005 0.0402,-0.11239 -0.008,-0.109258 -0.0598,-0.214928 -0.14133,-0.288073 -0.0591,-0.05301 -0.13989,-0.08312 -0.21975,-0.07386 -0.0915,0.01062 -0.17116,0.06585 -0.23465,0.129673 z",
    id: "path2576"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 107.69727,50.815398 c -0.12573,-0.335 -0.23548,-0.678325 -0.40258,-0.995384 -0.0274,-0.05201 -0.0392,-0.125198 -0.0928,-0.150056 -0.29456,-0.136841 -0.63607,-0.168739 -0.95049,-0.08417 -0.40724,0.109534 -0.75477,0.378386 -1.02274,0.696754 -0.27174,0.322853 -0.49971,0.696867 -0.59337,1.109672 -0.11291,0.497632 -0.1665,1.007458 -0.18705,1.516606 -0.0295,0.731466 -0.006,1.47228 0.16063,2.187235 0.10356,0.445302 0.25735,0.89304 0.54594,1.254152 0.17917,0.224191 0.41604,0.426243 0.69998,0.483675 0.19264,0.03896 0.38923,-0.0178 0.56716,-0.08877 0.29004,-0.115685 0.55819,-0.278044 0.82498,-0.438373 0.60839,-0.365617 1.14647,-0.843767 1.59258,-1.395848 0.10001,-0.123767 0.19366,-0.252818 0.27067,-0.392646 0.11526,-0.209271 0.21152,-0.435251 0.38259,-0.607063",
    id: "path2580"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 112.46477,52.579988 c -0.0329,-0.397779 -0.0883,-0.794 -0.1701,-1.184577 -0.0374,-0.178868 -0.078,-0.35816 -0.14855,-0.52763 -0.0807,-0.193903 -0.17851,-0.390653 -0.34166,-0.528193 -0.0603,-0.05082 -0.12741,-0.110137 -0.20651,-0.11239 -0.33051,-0.0094 -0.66691,0.07561 -0.9411,0.264656 -0.3156,0.217595 -0.53424,0.547963 -0.68652,0.894227 -0.23106,0.525385 -0.32362,1.096204 -0.43116,1.656796 -0.06,0.312815 -0.0401,0.635063 0.0158,0.94693 0.0615,0.342876 0.14894,0.680053 0.22615,1.01962 0.062,0.272672 0.18072,0.539846 0.37943,0.740971 0.15116,0.152998 0.35629,0.252904 0.57115,0.269282 0.21494,0.01638 0.4311,-0.01455 0.63967,-0.06504 0.12132,-0.02937 0.2395,-0.07036 0.35591,-0.114988 0.22291,-0.08546 0.4264,-0.21669 0.60326,-0.376566 0.17986,-0.16259 0.3496,-0.335804 0.5171,-0.510931 0.18958,-0.198217 0.29402,-0.461637 0.35441,-0.725039 0.0893,-0.389453 0.10102,-0.793427 0.0685,-1.190485 -0.0161,-0.196333 -0.048,-0.390811 -0.0778,-0.585391 -0.0444,-0.290208 -0.0862,-0.585075 -0.19549,-0.858871 -0.0402,-0.100831 -0.0811,-0.207171 -0.15885,-0.284377 -0.11152,-0.110727 -0.23841,-0.208653 -0.37958,-0.277136 -0.0587,-0.02847 -0.1208,-0.06217 -0.18792,-0.05859 -0.0556,0.003 -0.0558,0.06891 -0.0454,0.110311 0.0118,0.0472 0.032,0.09181 0.0535,0.135271",
    id: "path2584"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 114.50798,51.094008 c -0.0665,0.740186 0.0265,1.482254 0.13376,2.213899 0.0785,0.535845 0.16124,1.071019 0.24065,1.606781 0.0228,0.153832 0.0591,0.305985 0.0718,0.461019 0.0162,0.197961 0.003,0.396748 0.0229,0.594869 0.009,0.09427 0.0246,0.377819 0.0255,0.283133 0.005,-0.517947 -0.0954,-1.029517 -0.10834,-1.546813 -0.0252,-1.009044 0.1738,-2.017037 0.52943,-2.958041 0.0888,-0.235102 0.17388,-0.473109 0.29117,-0.695738 0.10409,-0.197566 0.22944,-0.390901 0.40704,-0.530622 0.12087,-0.09509 0.28272,-0.146175 0.43518,-0.107745 0.0973,0.02453 0.18472,0.07709 0.27119,0.126334 0.0493,0.02808 0.0674,0.08639 0.0848,0.136424 0.0819,0.234874 0.12521,0.481055 0.16609,0.725657 0.129,0.771786 0.18974,1.552948 0.30023,2.32725 0.0665,0.465904 0.12973,0.932738 0.16662,1.401837 0.0124,0.157413 0.0151,0.314764 0.0328,0.472932 0.003,0.02966 0.0212,0.05859 0.0331,0.01343 0.0515,-0.19533 0.0413,-0.399926 0.0312,-0.599513 -0.009,-0.169087 -0.0115,-0.338315 -0.002,-0.507701 0.032,-0.598568 0.0595,-1.204492 0.22492,-1.784656 0.0895,-0.314086 0.23783,-0.606332 0.37906,-0.900346 0.13554,-0.282171 0.21408,-0.593358 0.39327,-0.85364 0.0839,-0.121914 0.18681,-0.27153 0.33672,-0.283814 0.0584,-0.0048 0.10068,0.04717 0.13159,0.08911 0.11402,0.15467 0.19517,0.330506 0.26904,0.506861 0.0796,0.19001 0.16083,0.380445 0.21546,0.579352 0.11193,0.407569 0.12811,0.833936 0.23895,1.242087 0.1238,0.455867 0.32037,0.893171 0.38454,1.364184 0.0314,0.230406 0.0315,0.46352 0.0361,0.695571 0.008,0.395709 -10e-4,0.792323 0.03,1.187096 0.004,0.05294 0.009,0.10583 0.0168,0.158421",
    id: "path2588"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g25724"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 63.303793,59.669318 c -0.215282,-0.114775 -0.452727,-0.200826 -0.699116,-0.205531 -0.180988,-0.0035 -0.364399,0.04811 -0.51121,0.156052 -0.1677,0.123304 -0.277708,0.312413 -0.330035,0.511672 -0.07427,0.282827 -0.04458,0.585745 0.0516,0.859685 0.04872,0.138755 0.122588,0.266527 0.196362,0.393594 0.04495,0.07743 0.05137,0.177004 0.117306,0.240591 0.044,0.04243 0.101004,0.0693 0.157877,0.08971 0.155942,0.05595 0.325838,0.04907 0.487033,0.02267 0.201257,-0.03297 0.394978,-0.09873 0.592104,-0.149041",
    id: "path2592"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 66.151913,59.886028 c -0.08873,-0.137721 -0.144824,-0.298369 -0.261518,-0.416438 -0.07907,-0.08 -0.176837,-0.1493 -0.29035,-0.167133 -0.110948,-0.01743 -0.222163,0.01537 -0.323794,0.05706 -0.0665,0.02728 -0.133769,0.05342 -0.197291,0.08713 -0.162382,0.08616 -0.283928,0.235755 -0.357411,0.40229 -0.09974,0.226035 -0.127545,0.480072 -0.0987,0.724047 0.02486,0.210235 0.08996,0.420203 0.215001,0.593109 0.08728,0.120688 0.211885,0.218504 0.358258,0.255272 0.146433,0.03678 0.301042,0.0057 0.437779,-0.05292 0.11093,-0.04753 0.231818,-0.08094 0.324962,-0.161547 0.07497,-0.06488 0.114527,-0.16085 0.130345,-0.257102 0.02628,-0.159896 0.0164,-0.322488 0.03695,-0.483258 0.02459,-0.192409 0.02586,-0.386987 0.02577,-0.580512 z",
    id: "path2596"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 67.390223,59.607408 c 0.01192,0.267298 0.02904,0.534392 0.03232,0.802052 0.0055,0.451714 0.02051,0.903664 0.0073,1.355259 -0.0018,0.06127 -0.0211,0.123705 -0.0085,0.183767 0.0024,0.01135 -0.0059,0.01527 -0.0078,0.0041 -0.01268,-0.07412 -0.01597,-0.14954 -0.0201,-0.224512 -0.02316,-0.420963 -0.03646,-0.842541 -0.03775,-1.264112 -7.24e-4,-0.237836 -0.0047,-0.476227 0.01431,-0.71344 0.0054,-0.06768 0.01434,-0.1357 0.04054,-0.19937 0.03514,-0.08538 0.101843,-0.159565 0.189084,-0.193495 0.107737,-0.0419 0.229092,-0.02736 0.335374,0.01113 0.156891,0.05682 0.298065,0.159098 0.39818,0.292618 0.07032,0.09379 0.120464,0.209748 0.111035,0.329258 -0.008,0.100894 -0.06665,0.191097 -0.142532,0.2556 -0.115589,0.09826 -0.258135,0.156731 -0.401374,0.202093 -0.153477,0.0486 -0.312879,0.0897 -0.448125,0.180676",
    id: "path2600"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 69.681103,59.545488 c 0.171082,0.0595 0.355273,0.06895 0.534642,0.05728 0.274383,-0.01786 0.542958,-0.0814 0.809466,-0.145786 0.167267,-0.04041 0.3336,-0.08651 0.503794,-0.113022 0.05438,-0.0085 0.109244,-0.01504 0.164348,-0.01517",
    id: "path2604"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 70.702703,59.669318 c -0.0066,0.188364 0.0092,0.376687 0.02962,0.563769 0.04096,0.37554 0.109193,0.747432 0.155977,1.122186 0.0148,0.118585 0.03004,0.237592 0.03112,0.357265",
    id: "path2608"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 72.653043,59.359748 c 0.0079,0.173407 0.009,0.347044 0.0099,0.520597 0.0025,0.469231 0.0033,0.938529 -0.005,1.407692 -0.0013,0.07292 -0.0015,0.145892 -0.0049,0.218751",
    id: "path2612"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 75.284463,59.793148 c -0.113853,-0.09789 -0.190596,-0.233225 -0.314379,-0.320556 -0.06603,-0.04659 -0.149787,-0.06514 -0.229618,-0.05296 -0.122916,0.01876 -0.23139,0.08417 -0.33693,0.145636 -0.05516,0.03213 -0.114888,0.05693 -0.164428,0.09826 -0.110519,0.0922 -0.183106,0.22165 -0.233177,0.354572 -0.08115,0.215419 -0.115625,0.447254 -0.111247,0.676771 0.0036,0.190262 0.03096,0.383176 0.106486,0.559064 0.04076,0.09491 0.101249,0.181395 0.179456,0.249725 0.196891,0.172025 0.479606,0.243368 0.733705,0.17672 0.141705,-0.03717 0.271386,-0.12415 0.352273,-0.247516 0.03697,-0.05638 0.06349,-0.119343 0.07977,-0.184698",
    id: "path2616"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 78.194493,59.514538 c -0.02435,0.405292 0.0095,0.811212 0.0539,1.213932 0.02252,0.204283 0.04782,0.408249 0.06993,0.612578",
    id: "path2620"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 79.494723,59.452618 c -0.01846,0.12491 -0.02475,0.251262 -0.02868,0.377328 -0.0089,0.28662 -0.0065,0.573532 0.0033,0.860074 0.0049,0.144188 0.0087,0.288572 0.02194,0.432271 0.001,0.01102 0.0021,0.02203 0.0035,0.03301",
    id: "path2624"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 78.349283,60.350398 c 0.149203,-0.0076 0.298237,-0.01805 0.447277,-0.02829 0.05952,-0.0041 0.119416,-0.0062 0.178864,5.15e-4 0.08517,0.0096 0.169824,0.02316 0.254672,0.03517 0.05722,0.0081 0.114467,0.01596 0.171747,0.0236",
    id: "path2628"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 80.671113,59.421658 c 0.226663,0.281627 0.452376,0.564036 0.681692,0.84351 0.0059,0.0071 0.01171,0.01426 0.01758,0.02138",
    id: "path2632"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 81.599853,59.359748 c -0.105997,0.328071 -0.149181,0.672292 -0.173817,1.014989 -0.03059,0.42557 -0.03447,0.854087 -0.104803,1.275881",
    id: "path2636"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 82.652413,61.217208 c 0.04686,-0.11157 0.08426,-0.226818 0.123359,-0.341258 0.12115,-0.354576 0.237069,-0.71148 0.381144,-1.057581 0.03222,-0.07741 0.07257,-0.307147 0.103556,-0.229211 0.103713,0.260889 0.230267,0.512195 0.36726,0.756997 0.101288,0.180998 0.261516,0.728127 0.324951,0.530553 0.05179,-0.161291 0.08148,-0.328472 0.112948,-0.494593 0.04758,-0.25116 0.08811,-0.5047 0.163462,-0.749409 0.02127,-0.06907 0.03088,-0.259248 0.07619,-0.202871 0.165252,0.205609 0.285214,0.443642 0.38252,0.687593 0.135188,0.338923 0.231889,0.692559 0.30244,1.050274",
    id: "path2640"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 86.491183,61.371998 c -0.01255,-0.231909 -0.02658,-0.463737 -0.03507,-0.695861 -0.01084,-0.296482 -0.03026,-0.592649 -0.03752,-0.889236 -0.0014,-0.05817 0.0012,-0.116369 -2.43e-4,-0.174626 -2.51e-4,-0.01009 0.0069,-0.03994 0.01868,-0.02167 0.02536,0.03945 0.04095,0.08422 0.05837,0.127524 0.04165,0.103507 0.06353,0.219107 0.130988,0.308002 0.219526,0.289286 0.408043,0.600208 0.599027,0.908592 0.03738,0.06035 0.06058,0.228788 0.112767,0.180662 0.01943,-0.01792 0.01758,-0.05112 0.01988,-0.07632 0.01236,-0.13548 0.01481,-0.271628 0.01772,-0.407561 0.0075,-0.350548 0.0027,-0.701367 0.01621,-1.051745 0.0026,-0.06686 0.0037,-0.133989 0.01217,-0.200426",
    id: "path2644"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 89.896543,59.731238 c -0.109185,-0.08681 -0.179996,-0.21312 -0.294401,-0.294233 -0.04767,-0.0338 -0.106338,-0.04703 -0.164958,-0.046 -0.167227,0.0029 -0.337119,0.05011 -0.470964,0.153583 -0.141437,0.109346 -0.230161,0.274566 -0.272064,0.446077 -0.05712,0.233794 -0.04433,0.481065 0.01478,0.71291 0.05637,0.221123 0.151201,0.437583 0.30401,0.608858 0.059,0.06613 0.124361,0.129417 0.203036,0.171111 0.09874,0.05233 0.217161,0.05 0.322537,0.02103 0.158913,-0.04369 0.301746,-0.133388 0.425889,-0.239774 0.144511,-0.123841 0.273464,-0.270331 0.358239,-0.441473 0.04769,-0.09628 0.08833,-0.203661 0.07509,-0.312218 -0.01098,-0.09003 -0.05032,-0.174012 -0.09562,-0.25145 -0.112575,-0.192417 -0.26607,-0.355926 -0.405562,-0.528422 z",
    id: "path2648"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 91.506343,59.297828 c 0.07028,0.215794 0.07607,0.446891 0.05267,0.671032 -0.03961,0.379344 -0.157338,0.746876 -0.180714,1.128313 -0.0094,0.154085 -0.114813,0.422227 0.03514,0.460575 0.0445,0.01138 0.09227,0.0079 0.138111,0.0075 0.257444,-0.0022 0.514844,-0.01263 0.771628,-0.03068 0.161323,-0.01134 0.323793,-0.01744 0.482983,-0.04663 0.03143,-0.0058 0.06374,-0.01023 0.09325,-0.02308",
    id: "path2652"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 95.325481,59.486993 c -0.133446,-0.02985 -0.275332,-0.0049 -0.395811,0.058 -0.164339,0.08578 -0.290817,0.229655 -0.386166,0.386696 -0.07317,0.120515 -0.1091,0.259913 -0.122131,0.399356 -0.02487,0.266137 0.01764,0.531745 0.03733,0.79671 0.0082,0.110232 0.03517,0.225839 0.110354,0.310837 0.05806,0.06564 0.14633,0.09785 0.232783,0.09836 0.133146,7.95e-4 0.261187,-0.05008 0.374122,-0.116794 0.201018,-0.118741 0.37115,-0.287625 0.498237,-0.482809 0.12421,-0.190766 0.208307,-0.414247 0.205934,-0.644206 -0.0013,-0.128968 -0.06149,-0.247 -0.09028,-0.37275 -0.01938,-0.08467 -0.07127,-0.157898 -0.129718,-0.22021 -0.07838,-0.08357 -0.171596,-0.156875 -0.279678,-0.196948 -0.01793,-0.0066 -0.03627,-0.01222 -0.05497,-0.01624 z",
    id: "path2656"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 98.440893,59.421658 c -0.204315,-0.07087 -0.430757,-0.08796 -0.639916,-0.0257 -0.22824,0.06795 -0.420244,0.227436 -0.556851,0.419375 -0.178733,0.251127 -0.282332,0.553456 -0.305649,0.859841 -0.01709,0.224527 0.0072,0.457911 0.10637,0.662609 0.06981,0.144073 0.187118,0.267221 0.335448,0.331355 0.17534,0.07581 0.375698,0.06999 0.557177,0.02251 0.15637,-0.0409 0.314571,-0.08652 0.453506,-0.171267 0.08777,-0.05354 0.169916,-0.128865 0.200982,-0.230017 0.03032,-0.09874 -0.0016,-0.20255 -0.04361,-0.293736 -0.02571,-0.05583 -0.06916,-0.101854 -0.121079,-0.134444 -0.101207,-0.06353 -0.216714,-0.0964 -0.326922,-0.140304 -0.02807,-0.01118 -0.112888,0.0046 -0.0929,0 0.133135,-0.03057 0.268691,-0.04917 0.403959,-0.06727 0.154051,-0.02062 0.308221,-0.0409 0.462861,-0.05656",
    id: "path2660"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 99.895903,59.421658 c 0.03905,0.135244 0.07339,0.271883 0.115867,0.406098 0.0223,0.07044 0.0446,0.141963 0.0829,0.205733 0.028,0.04677 0.0697,0.08391 0.116,0.112038 0.0689,0.04183 0.14265,0.07479 0.21498,0.110126 0.0216,0.01053 0.0431,0.02115 0.0645,0.03188",
    id: "path2664"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 100.63889,59.390708 c 0.009,0.113047 0.007,0.226668 0.004,0.339907 -0.0102,0.368728 -0.0333,0.73693 -0.0535,1.105202 -0.0159,0.29024 -0.0353,0.580406 -0.0418,0.871043 -7.4e-4,0.03284 -0.001,0.06569 -0.001,0.09855",
    id: "path2668"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 104.53957,60.474228 c -0.1269,0.226419 -0.20871,0.478038 -0.36376,0.688317 -0.0581,0.07884 -0.12608,0.149753 -0.19418,0.219881 -0.11272,0.116077 -0.22878,0.232384 -0.36757,0.316868 -0.0693,0.04217 -0.14655,0.08093 -0.22984,0.07779 -0.0611,-0.0023 -0.11384,-0.04368 -0.14294,-0.09583 -0.0449,-0.08047 -0.0594,-0.173993 -0.065,-0.26466 -0.007,-0.120372 0.0402,-0.237959 0.11229,-0.332547 0.10471,-0.137357 0.24554,-0.241085 0.3864,-0.338424 0.20678,-0.142894 0.4284,-0.266601 0.61662,-0.434512 0.10612,-0.09467 0.20457,-0.20822 0.24333,-0.348117 0.0336,-0.121211 0.0129,-0.253756 -0.0447,-0.364016 -0.0421,-0.08052 -0.12223,-0.138691 -0.21168,-0.155181 -0.13094,-0.02414 -0.26648,0.02819 -0.36437,0.114933 -0.10974,0.09725 -0.16972,0.242485 -0.17504,0.387939 -0.007,0.184416 0.0614,0.363482 0.15528,0.519211 0.0478,0.07938 0.10153,0.155627 0.16647,0.222224 0.14255,0.146182 0.29615,0.280988 0.44768,0.417664 0.15368,0.138615 0.31516,0.269473 0.45749,0.419836 0.0344,0.03632 0.0727,0.07067 0.0972,0.114825 0,0 0.002,0.0056 0.002,0.0056 0,0 6.7e-4,0.0046 6.7e-4,0.0046",
    id: "path2672"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 107.17098,61.279128 c 0.0526,-0.237246 0.0524,-0.481503 0.0662,-0.722979 0.0116,-0.203212 0.0278,-0.410033 0.0989,-0.602471 0.0463,-0.125346 0.12621,-0.235802 0.22284,-0.329247 0.0326,-0.0315 0.089,-0.03897 0.12047,1.83e-4 0.0397,0.04933 0.057,0.112024 0.0714,0.172417 0.0435,0.182934 0.0634,0.370491 0.10279,0.554255 0.027,0.125975 0.0558,0.254604 0.11979,0.367649 0.0347,0.0613 0.0864,0.121152 0.15817,0.136339 0.0538,0.01139 0.11333,0.0029 0.15942,-0.02666 0.0705,-0.04523 0.10859,-0.12504 0.13405,-0.201767 0.049,-0.147585 0.066,-0.303227 0.0795,-0.457418 0.0115,-0.131919 0.01,-0.264962 0.0273,-0.396268 0.015,-0.114333 0.0137,-0.229966 0.0313,-0.344348 0.004,-0.02528 0.0253,-0.0727 0.0548,-0.04534 0.0393,0.03635 0.0673,0.08297 0.0947,0.128448 0.10832,0.179826 0.20269,0.367598 0.29664,0.555188 0.16244,0.324353 0.32749,0.647666 0.47543,0.97886 0.012,0.02677 0.0473,0.07963 0.006,0.09338 -0.0192,0.0063 -0.0447,-9.29e-4 -0.0593,0.01597",
    id: "path2676"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 112.27902,59.762198 c -0.0892,-0.135424 -0.1932,-0.266751 -0.33152,-0.354946 -0.0923,-0.05887 -0.20676,-0.08844 -0.31537,-0.06401 -0.12597,0.02834 -0.2297,0.11585 -0.30814,0.214795 -0.12763,0.160992 -0.21024,0.353594 -0.26366,0.550614 -0.0638,0.235445 -0.094,0.483418 -0.0618,0.72609 0.0203,0.152897 0.0663,0.307873 0.16456,0.429807 0.0724,0.08985 0.17949,0.148812 0.29321,0.166751 0.15995,0.02523 0.32421,-0.01507 0.46715,-0.08649 0.14368,-0.07179 0.27516,-0.174571 0.36522,-0.308958 0.0694,-0.103616 0.0908,-0.230636 0.0971,-0.35278 0.0102,-0.197543 -0.0132,-0.395062 -0.0448,-0.589729 -0.018,-0.110844 -0.0398,-0.221134 -0.0619,-0.331143 z",
    id: "path2680"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 113.70308,59.514538 c -0.0268,-0.04707 -0.0566,-0.09246 -0.0885,-0.136779 -0.0155,-0.02156 -0.0297,-1.66e-4 -0.0295,0.01902 7.7e-4,0.0748 0.0182,0.148327 0.0352,0.220739 0.0699,0.297303 0.157,0.590283 0.24757,0.881829 0.091,0.292853 0.17467,0.588622 0.28569,0.874527 0.01,0.02464 0.0322,0.09997 0.0299,0.07357 -0.004,-0.04699 -0.0202,-0.09389 -0.0351,-0.139025 -0.0632,-0.191679 -0.13704,-0.379677 -0.19982,-0.571519 -0.0823,-0.251437 -0.15759,-0.508264 -0.17857,-0.772961 -0.0128,-0.161271 -0.01,-0.330585 0.0569,-0.480366 0.0501,-0.112739 0.14467,-0.199403 0.24763,-0.263726 0.13474,-0.08418 0.29081,-0.13896 0.45054,-0.14211 0.11846,-0.0023 0.24179,0.03261 0.32808,0.117352 0.0896,0.088 0.12869,0.215896 0.13083,0.339095 0.003,0.172871 -0.0478,0.344072 -0.13015,0.494728 -0.0608,0.111306 -0.13747,0.218216 -0.24239,0.291701 -0.0613,0.04292 -0.1414,0.07299 -0.21557,0.04679 -0.0279,-0.0099 -0.10308,-0.04605 -0.0737,-0.04797 0.05,-0.0033 0.10031,0.0053 0.14927,0.01503 0.20881,0.04172 0.40525,0.153157 0.53923,0.320335 0.0741,0.09247 0.12859,0.20059 0.1566,0.315966 0.0455,0.187615 0.0392,0.383619 0.0141,0.573708 -0.0185,0.140422 -0.0498,0.278725 -0.0853,0.415717",
    id: "path2684"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 118.161,59.576448 c -0.13733,-0.02318 -0.2726,-0.05703 -0.40977,-0.08119 -0.18717,-0.03296 -0.37892,-0.05692 -0.56868,-0.03366 -0.13039,0.01599 -0.26169,0.05961 -0.36141,0.148218 -0.10338,0.09186 -0.16044,0.226711 -0.1752,0.362642 -0.0189,0.174172 0.0149,0.347817 0.0382,0.51982 0.0179,0.13238 0.0297,0.267054 0.0102,0.400373 -0.0177,0.121192 -0.0593,0.237803 -0.0738,0.359448 -0.007,0.05689 -0.008,0.121682 0.0296,0.168694 0.0405,0.05059 0.10842,0.0666 0.16976,0.0718 0.0716,0.0061 0.14365,0.0032 0.21544,0.0023 0.40721,-0.005 0.81401,-0.02856 1.22128,-0.02999 0.009,-3.3e-5 0.0188,-5e-5 0.0283,-5e-5",
    id: "path2688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#757575",
      strokeWidth: 0.529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 116.82982,60.412308 c 0.16292,-0.01563 0.32563,-0.03508 0.48652,-0.06565 0.0362,-0.0069 0.0734,-0.01316 0.11028,-0.0071 0.0498,0.0082 0.0985,0.02198 0.14741,0.03431 0.01,0.0025 0.0198,0.005 0.0297,0.0075",
    id: "path2692"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16491",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-73.932107,-56.174742)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 134.48066,128.10335 c 0.008,0.81533 -0.0944,1.62645 -0.11783,2.44077 -0.0184,0.63885 -0.008,1.29001 0.1704,1.90865 0.1253,0.43468 0.37823,0.82765 0.72137,1.13011 0.0778,0.0686 0.11702,0.20029 0.22771,0.21423 0.15776,0.0199 0.32744,-0.0412 0.42134,-0.17364 0.12818,-0.1808 0.15542,-0.4089 0.17018,-0.62432 0.0186,-0.27167 -0.0153,-0.54697 0.0344,-0.81573 0.0122,-0.0662 -0.0101,-0.23247 0.0492,-0.19767 0.0562,0.033 0.0753,0.12849 0.10192,0.19253 0.23311,0.56144 0.37693,1.16308 0.69842,1.68555 0.23754,0.38604 0.57648,0.7036 0.96397,0.93695 0.4897,0.29491 1.05621,0.4278 1.5657,0.68038 0.12321,0.0611 0.20835,0.18122 0.33857,0.23021 0.0827,0.0311 0.13125,-0.0518 0.12039,-0.12961 -0.0293,-0.21024 -0.10254,-0.41103 -0.16755,-0.61215 -0.1152,-0.35637 -0.2617,-0.70697 -0.31775,-1.07825 -0.0168,-0.11142 -0.11247,-0.3482 0.004,-0.33944 0.14506,0.0109 0.28898,0.038 0.43257,0.0618 0.84731,0.14029 1.69331,0.2885 2.53881,0.43933 0.17086,0.0305 0.34409,0.0567 0.50705,0.11598 0.0835,0.0304 0.0881,-0.0521 0.066,-0.11583 -0.0817,-0.23631 -0.27225,-0.41005 -0.37515,-0.63682 -0.41024,-0.9041 -0.90408,-1.77907 -1.19384,-2.72875 -0.0344,-0.11281 0.0414,-0.22011 0.11147,-0.30141 0.132,-0.15315 0.30142,-0.26975 0.42591,-0.43017 0.0456,-0.0588 0.0624,-0.1502 7.6e-4,-0.2062 -0.13325,-0.12109 -0.31385,-0.16753 -0.48403,-0.21065 -0.19075,-0.0483 -0.39139,-0.0621 -0.57453,-0.13565 -0.62294,-0.25012 -1.23787,-0.52789 -1.81034,-0.8768 -0.063,-0.0384 -0.17822,-0.0566 -0.17958,-0.13224 -0.001,-0.0777 0.12565,-0.058 0.17996,-0.0565 0.31842,0.009 0.6373,0.0979 0.95373,0.0555 0.0593,-0.008 0.20528,-0.0113 0.17069,-0.0874 -0.0377,-0.083 -0.10905,-0.1473 -0.17459,-0.20881 -0.34605,-0.32476 -0.79572,-0.51363 -1.24753,-0.63729 -0.71925,-0.19686 -1.469,-0.26144 -2.21248,-0.25624 -0.35624,0.002 -0.7128,0.0203 -1.06652,0.0637",
    id: "path2696"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 138.65996,130.85859 c -0.67599,-0.31478 -1.32928,-0.68522 -1.92341,-1.13698 -0.28402,-0.21596 -0.52141,-0.48425 -0.78053,-0.73033 -0.42644,-0.40498 -0.73199,-0.92493 -0.93667,-1.4721 -0.18562,-0.49621 -0.31453,-1.02968 -0.2642,-1.56141 0.0242,-0.25514 0.0928,-0.51531 0.25905,-0.7179 0.26222,-0.31957 0.59986,-0.57032 0.95839,-0.77078 0.28838,-0.16124 0.59185,-0.31949 0.92277,-0.35929 0.30092,-0.0362 0.61032,-0.0158 0.90317,-0.11694 0.46755,-0.16146 0.96699,-0.30069 1.46255,-0.22994 0.55426,0.0791 1.11063,0.1611 1.6504,0.31265 0.19251,0.0541 0.38173,0.12783 0.54188,0.25188 0.37726,0.29221 0.71681,0.62961 1.04634,0.97352 0.2759,0.28794 0.55926,0.5704 0.80945,0.8812 0.41564,0.51633 0.78522,1.08181 1.30359,1.504 0.26506,0.21588 0.5891,0.3956 0.94008,0.38607 0.41625,-0.0113 0.82007,-0.13932 1.20122,-0.29775 0.53567,-0.22266 1.04673,-0.50747 1.51275,-0.854 0.42818,-0.31839 0.72775,-0.7678 1.10174,-1.14173 0.12451,-0.12449 0.25854,-0.24013 0.40528,-0.3378",
    id: "path2700"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 149.77381,125.44096 c 0.28681,-0.18357 0.57057,-0.37315 0.87788,-0.52248 0.40845,-0.19848 0.86053,-0.32242 1.22725,-0.59198 0.72977,-0.53643 1.57991,-0.88642 2.45202,-1.11611 1.026,-0.27022 2.07842,-0.41398 3.12177,-0.59781 1.03162,-0.18176 2.09727,-0.13126 3.1168,0.10583 0.2615,0.0608 0.51275,0.16055 0.77422,0.22024 0.4805,0.10969 0.91813,0.34566 1.34246,0.58876 0.36708,0.2103 0.73927,0.41783 1.14244,0.55143",
    id: "path2704"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 163.82824,124.07843 c -0.22688,0.17427 -0.47861,0.32125 -0.66667,0.54152 -0.51766,0.60631 -1.01418,1.23104 -1.55064,1.82101 -0.20503,0.22548 -0.44693,0.41755 -0.63633,0.65715 -0.0739,0.0934 -0.16262,0.004 -0.20886,-0.0699 -0.17174,-0.27312 -0.27243,-0.58279 -0.40458,-0.87552 -0.0554,-0.12263 -0.0524,-0.31792 -0.18062,-0.36212 -0.0739,-0.0255 -0.13036,0.0951 -0.17039,0.15233 -0.11474,0.16406 -0.23251,0.34003 -0.42272,0.4268 -0.39139,0.17854 -0.70051,0.51826 -1.12363,0.62742 -0.17311,0.0447 -0.3743,0.0516 -0.52492,-0.0618 -0.23155,-0.17435 -0.39056,-0.42296 -0.54308,-0.66481 -0.20618,-0.32694 -0.34363,-0.69996 -0.59117,-0.99704 -0.0495,-0.0594 -0.11218,-0.17793 -0.20261,-0.13094 -0.11036,0.0573 -0.2012,0.14319 -0.3057,0.2109 -0.94415,0.61174 -2.02834,0.96427 -2.9964,1.52977 -0.38423,0.22445 -0.74387,0.49544 -1.15276,0.67423 -0.0768,0.0336 -0.1692,0.0872 -0.22376,-0.0298 -0.19235,-0.4123 -0.31882,-0.86239 -0.58127,-1.23549 -0.0434,-0.0616 -0.0918,-0.16111 -0.18905,-0.12629 -0.30189,0.10813 -0.57255,0.28625 -0.86902,0.40732 -0.21983,0.0898 -0.46308,0.17723 -0.70324,0.12096 -0.1536,-0.036 -0.25276,-0.16743 -0.33149,-0.29625 -0.15935,-0.26075 -0.23937,-0.58185 -0.15939,-0.88317 0.0994,-0.37467 0.35231,-0.68251 0.60328,-0.96692 0.51215,-0.58039 0.983,-1.20046 1.55029,-1.72963 0.17069,-0.15922 0.59165,-0.21367 0.54255,-0.44199 -0.0232,-0.10783 -0.16496,-0.10762 -0.25217,-0.12144 -0.14021,-0.0222 -0.3046,0.014 -0.42177,-0.0703 -0.0949,-0.0683 0.0255,-0.16703 0.0857,-0.2107 0.43477,-0.31529 0.95368,-0.48884 1.47119,-0.61131 0.65915,-0.15599 1.33244,-0.25279 2.0077,-0.29187 0.51009,-0.0295 1.02444,0.13811 1.52819,0.0321 0.1371,-0.0288 0.18469,-0.17906 0.20246,-0.30151 0.0377,-0.26 -0.008,-0.52958 0.0681,-0.7845 0.0326,-0.10853 0.13669,-0.19314 0.25161,-0.18417 0.22407,0.0175 0.4449,0.0677 0.66249,0.12264 0.71495,0.18056 1.41378,0.42448 2.08853,0.71863 0.27765,0.12104 0.53345,0.32111 0.84301,0.3427 0.11458,0.008 0.13629,-0.12814 0.13762,-0.21595 0.004,-0.28762 -0.0584,-0.56927 -0.0627,-0.85814 -0.002,-0.10095 0.0885,-0.17986 0.19331,-0.14362 0.14652,0.0507 0.26749,0.15084 0.39506,0.2357 0.33574,0.22333 0.6637,0.45849 0.97501,0.71561 0.50665,0.41845 1.03006,0.83946 1.39386,1.39556 0.23375,0.35731 0.35803,0.77371 0.41829,1.19614 0.0311,0.21789 0.14599,0.43508 0.0869,0.65711 -0.007,0.0275 -0.0175,0.0543 -0.0303,0.0796 z",
    id: "path2708"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 163.82824,124.07843 c 0.22936,0.0955 0.46411,0.17738 0.69346,0.27285 0.14462,0.0602 0.28073,0.14195 0.3964,0.24819 0.18245,0.16758 0.33873,0.36088 0.49627,0.55128 0.063,0.0761 0.12871,0.1513 0.17041,0.24216 0.0979,0.21326 0.1432,0.44635 0.17379,0.67745 0.0619,0.46763 0.0738,0.9421 0.0369,1.41201 -0.0219,0.27821 -0.0558,0.55747 -0.13421,0.82635 -0.0357,0.12256 -0.10026,0.23489 -0.18181,0.33259 -0.17706,0.21212 -0.40606,0.37644 -0.65073,0.50144 -0.22011,0.11245 -0.45615,0.20473 -0.70356,0.22824 -0.30241,0.0287 -0.60487,-0.0545 -0.87636,-0.18239 -0.36207,-0.17059 -0.69107,-0.41217 -0.96179,-0.70622 -0.10202,-0.11081 -0.20652,-0.22329 -0.27776,-0.35635 -0.0846,-0.15803 -0.13356,-0.33256 -0.1706,-0.50694 -0.0562,-0.26442 -0.0967,-0.53609 -0.076,-0.80632 0.009,-0.1191 0.0207,-0.24558 0.0863,-0.34818 0.0159,-0.0248 0.0357,-0.0475 0.0603,-0.0639",
    id: "path2712"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 160.86496,127.16216 c -0.36861,0.17662 -0.73351,0.36276 -1.08155,0.57727 -0.17658,0.10883 -0.35251,0.22132 -0.50842,0.35908 -0.14559,0.12864 -0.22257,0.31992 -0.24253,0.51029 -0.0267,0.25498 0.0243,0.50896 0.0694,0.75862 0.0631,0.34945 0.1576,0.69944 0.33778,1.00829 0.13435,0.23029 0.32931,0.42924 0.57143,0.54597 0.27124,0.13077 0.58208,0.14938 0.87767,0.11612 0.39998,-0.045 0.78331,-0.19711 1.11887,-0.41726 0.49658,-0.32579 0.8931,-0.77796 1.26177,-1.23771",
    id: "path2716"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 164.16918,129.55837 c 0.18125,0.29104 0.38372,0.57379 0.50359,0.89771 0.0659,0.17814 0.10945,0.3656 0.11999,0.55535 0.006,0.11396 -0.0214,0.22799 -0.0747,0.32888 -0.0471,0.0894 -0.0947,0.17953 -0.1199,0.27853 -0.12494,0.49105 -0.4298,0.93108 -0.83984,1.22853 -0.41631,0.302 -0.94454,0.44952 -1.45753,0.39216 -0.41715,-0.0466 -0.8263,-0.22071 -1.12591,-0.51309 -0.10434,-0.10182 -0.13796,-0.25041 -0.23319,-0.35989 -0.15681,-0.18028 -0.3084,-0.37348 -0.38493,-0.60323 -0.0571,-0.17143 -0.0715,-0.3536 -0.0716,-0.53323",
    id: "path2720"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 159.52551,130.67285 c -0.14838,0.0967 -0.30585,0.17976 -0.44612,0.28855 -0.11056,0.0857 -0.20099,0.19707 -0.26051,0.32404 -0.047,0.10029 -0.083,0.2067 -0.0983,0.31614 -0.0281,0.20117 -0.0231,0.41367 0.058,0.60309 0.0638,0.14897 0.18148,0.27107 0.32187,0.35056 0.1894,0.10724 0.40806,0.15029 0.62315,0.16329 0.32041,0.0194 0.64206,-0.0183 0.95506,-0.0855 0.16483,-0.0354 0.32808,-0.0788 0.48755,-0.13367",
    id: "path2724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 161.16626,132.49944 c -0.3459,0.24096 -0.71658,0.45062 -1.02769,0.73797 -0.14704,0.13581 -0.28823,0.28471 -0.37953,0.46352 -0.0671,0.13142 -0.0898,0.28076 -0.0946,0.42663 -0.007,0.22716 0.0212,0.45668 0.0925,0.67255 0.0449,0.13598 0.10757,0.26987 0.21014,0.37286 0.17344,0.17416 0.39698,0.29014 0.62732,0.36942 0.33231,0.11438 0.68737,0.16571 1.03807,0.14381 0.25114,-0.0157 0.50647,-0.0652 0.72756,-0.18978 0.0724,-0.0408 0.14042,-0.0901 0.19928,-0.14894",
    id: "path2728"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 166.95538,126.896 c 0.0259,0.54443 0.0877,1.08978 0.0456,1.63507 -0.0196,0.25347 -0.001,0.53426 -0.13851,0.74868 -0.20564,0.32184 -0.48061,0.6023 -0.808,0.79998 -0.20939,0.12643 -0.44314,0.2249 -0.68926,0.2409 -0.0909,0.006 -0.1867,0.0115 -0.27202,-0.0211 -0.21592,-0.0825 -0.39668,-0.24995 -0.49773,-0.4577 -0.0477,-0.0981 -0.08,-0.20508 -0.0858,-0.31443",
    id: "path2732"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 167.66741,127.4842 c 0.49947,0.25887 1.00616,0.52432 1.42236,0.90854 0.25649,0.23678 0.47909,0.53421 0.5444,0.88435 0.0558,0.2994 -0.006,0.61896 -0.16191,0.87731 -0.16264,0.26888 -0.45431,0.43007 -0.75038,0.50999 -0.25491,0.0688 -0.52618,0.11435 -0.78575,0.0654 -0.2099,-0.0396 -0.38021,-0.17938 -0.56144,-0.28443 -0.0543,-0.0315 -0.17481,-0.15695 -0.16676,-0.0935 0.007,0.0553 0.0594,0.11157 0.0921,0.16259 0.19703,0.30785 0.31764,0.65263 0.4603,0.99428 0.10276,0.24609 0.20591,0.49815 0.23292,0.76608 0.0183,0.18122 -0.0319,0.37268 -0.15955,0.50701 -0.16772,0.17653 -0.4022,0.2685 -0.63062,0.33671 -0.35137,0.10493 -0.74297,0.10179 -1.07754,-0.0396 -0.22164,-0.0937 -0.4306,-0.21081 -0.64655,-0.31929 -0.0384,-0.0193 -0.12046,-0.0281 -0.0808,0.0426 0.0405,0.0721 0.10489,0.13829 0.10159,0.22913 -0.0113,0.3113 -0.1636,0.58976 -0.2634,0.8781 -0.1458,0.42125 -0.40239,0.80778 -0.75475,1.08444 -0.29306,0.2301 -0.63976,0.39135 -1.00245,0.47194 -0.39692,0.0882 -0.82254,-0.01 -1.15611,-0.23994 -0.43968,-0.30313 -0.72068,-0.83439 -0.69274,-1.37214 0.0105,-0.20154 0.0647,-0.40013 0.15519,-0.58036",
    id: "path2736"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 168.78189,131.04434 c 0.14773,0.27302 0.31796,0.53565 0.43109,0.82602 0.0854,0.21911 0.11734,0.45891 0.0869,0.69258 -0.0428,0.32861 -0.13983,0.66066 -0.33221,0.92707 -0.13014,0.18022 -0.28439,0.35465 -0.48886,0.45167 -0.15182,0.072 -0.32723,0.0774 -0.48929,0.0408 -0.24202,-0.0548 -0.45567,-0.19572 -0.69426,-0.2588 -0.04,-0.0106 -0.11754,-0.0719 -0.12556,-0.0401 -0.0261,0.10362 0.009,0.20932 0.0423,0.30707 0.0376,0.11122 0.0797,0.22153 0.0917,0.34002 0.0468,0.46088 -0.0611,0.94375 -0.33396,1.32256 -0.19279,0.2677 -0.4783,0.46737 -0.79855,0.55112 -0.30058,0.0786 -0.62016,0.0542 -0.91665,-0.0281 -0.24846,-0.069 -0.49345,-0.18045 -0.6767,-0.36652 -0.12925,-0.13124 -0.20874,-0.31148 -0.20868,-0.4972 3e-5,-0.0934 0.0181,-0.18619 0.0477,-0.2746",
    id: "path2740"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 164.60672,135.80959 c -0.0481,0.17332 -0.0432,0.35574 -0.0326,0.53357 0.0193,0.32248 0.0746,0.64354 0.0627,0.96733 -0.005,0.14193 -0.0313,0.28395 -0.0891,0.41498 -0.0907,0.20549 -0.23911,0.37953 -0.40563,0.52793 -0.14478,0.12903 -0.29553,0.25112 -0.44684,0.37233 -0.26138,0.20938 -0.54039,0.4057 -0.85569,0.52476 -0.22126,0.0836 -0.46785,0.11674 -0.69957,0.0557 -0.24494,-0.0645 -0.45111,-0.22762 -0.61574,-0.4151 -0.21979,-0.2503 -0.37843,-0.54583 -0.52789,-0.84168 -0.12777,-0.25292 -0.26076,-0.50954 -0.31321,-0.79049 -0.0279,-0.14965 -0.0386,-0.30711 10e-4,-0.45486 0.0464,-0.17087 0.12903,-0.32993 0.22471,-0.47786 0.10835,-0.16752 0.23082,-0.33021 0.38808,-0.4545 0.0626,-0.0495 0.13138,-0.0944 0.20937,-0.11469",
    id: "path2752"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 166.02041,136.42269 c 0.0683,0.13904 0.1601,0.26475 0.2347,0.40027 0.0483,0.0877 0.10013,0.17861 0.111,0.27942 0.0293,0.27132 0.0723,0.54404 0.0532,0.8175 -0.009,0.1234 -0.0229,0.25251 -0.0879,0.3597 -0.0398,0.0657 -0.0916,0.12358 -0.14624,0.17717 -0.25966,0.2547 -0.62402,0.39768 -0.98726,0.39276 -0.23424,-0.003 -0.47073,-0.076 -0.65499,-0.22375 -0.14725,-0.11809 -0.25309,-0.28259 -0.31176,-0.46113",
    id: "path2760"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 166.95538,135.96663 c 0.27047,0.44485 0.53576,0.89852 0.70824,1.39176 0.1196,0.34201 0.19157,0.7089 0.14695,1.07199 -0.0365,0.29707 -0.16735,0.57746 -0.35521,0.80975 -0.0868,0.10738 -0.19065,0.19882 -0.29266,0.29143 -0.14677,0.13325 -0.27162,0.29522 -0.4477,0.39256 -0.15157,0.0838 -0.3285,0.11368 -0.49996,0.10818 -0.33447,-0.0107 -0.65613,-0.15541 -0.90759,-0.3722 -0.23389,-0.20164 -0.41621,-0.47497 -0.47133,-0.78203 -0.0111,-0.0617 -0.0168,-0.12443 -0.0168,-0.18715",
    id: "path2764"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 164.8193,138.69092 c -0.10494,0.15515 -0.26235,0.26694 -0.43145,0.34346 -0.29269,0.13244 -0.61917,0.18131 -0.89807,0.34565 -0.16791,0.0989 -0.31542,0.24355 -0.38829,0.42735 -0.0879,0.22172 -0.0985,0.46598 -0.0795,0.70098 0.032,0.39482 0.13544,0.78195 0.28378,1.14813 0.11539,0.28484 0.25502,0.56249 0.44083,0.80856 0.10489,0.13891 0.23916,0.25522 0.39322,0.33712 0.22408,0.11912 0.48966,0.14724 0.73706,0.0971 0.33674,-0.0683 0.64036,-0.25866 0.87637,-0.50465 0.21734,-0.22653 0.37761,-0.50919 0.44947,-0.81645 0.0709,-0.3032 0.0687,-0.62151 0.004,-0.92553 -0.0244,-0.11458 -0.0427,-0.23325 -0.0942,-0.33851 -0.0411,-0.0842 -0.12424,-0.13647 -0.2022,-0.18246 -0.15083,-0.089 -0.31963,-0.14961 -0.45585,-0.26157 -0.0569,-0.0468 -0.10974,-0.11085 -0.10906,-0.18851",
    id: "path2768"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 159.64934,127.73186 c -1.18774,-0.0425 -2.37582,-0.1126 -3.56444,-0.0917 -0.95632,0.0168 -1.89115,0.24105 -2.82181,0.44093 -0.58661,0.12599 -1.20273,0.14966 -1.75882,0.38853 -0.33157,0.14243 -0.64523,0.32844 -0.92791,0.5519 -0.31059,0.24552 -0.5982,0.52973 -0.8037,0.87041 -0.15451,0.25615 -0.24993,0.56174 -0.19955,0.86371 0.0274,0.1641 0.11429,0.30833 0.19957,0.44875 0.0986,0.16235 0.22064,0.33477 0.41142,0.39005 0.2952,0.0855 0.607,0.0946 0.91181,0.0817 0.58345,-0.0246 1.17049,-0.11777 1.71498,-0.33205 0.32164,-0.12658 0.64964,-0.28744 0.86831,-0.56271 0.10273,-0.12932 0.18671,-0.28788 0.18514,-0.4559 -9.1e-4,-0.0973 -0.0872,-0.16639 -0.17611,-0.18688 -0.20125,-0.0464 -0.41152,-0.0122 -0.60839,0.0363 -0.18823,0.0464 -0.38422,0.0874 -0.55079,0.18825 -0.59634,0.36103 -1.06067,0.91285 -1.38335,1.52494 -0.3396,0.64418 -0.53845,1.37224 -0.51494,2.10418 0.0148,0.46176 0.16278,0.92615 0.45945,1.28623 0.29931,0.36328 0.74462,0.59135 1.20815,0.65387 0.29508,0.0398 0.59979,0.0333 0.88895,-0.0413 0.40081,-0.10343 0.77661,-0.32316 1.19921,-0.32699",
    id: "path2772"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 163.82865,124.07884 c 0.80536,-0.88238 1.66156,-1.71633 2.5075,-2.55934 0.48013,-0.47847 0.85327,-1.09344 1.43592,-1.44004 0.0802,-0.0477 0.11709,-0.29192 0.13836,-0.21873 0.0548,0.18847 0.0622,0.38867 0.0676,0.58417 0.01,0.35519 -0.16825,1.39212 -0.0319,1.06444 0.12359,-0.29701 0.37044,-0.5219 0.62383,-0.70847 0.54836,-0.40375 1.17084,-0.69911 1.81209,-0.92069 0.52496,-0.1814 1.06724,-0.34214 1.62476,-0.36502 0.11186,-0.005 0.24176,-0.0488 0.33537,0.0129 0.0837,0.0552 0.0354,0.17918 0.0114,0.25753 -0.12554,0.41011 -0.35895,0.77738 -0.51063,1.17685 -0.0425,0.11198 -0.0273,0.2472 -0.0966,0.34494 -0.0235,0.0331 -0.10161,0.10156 -0.012,0.0574 0.51784,-0.25525 1.09758,-0.34613 1.66971,-0.37508 0.69813,-0.0353 1.40193,0.0396 2.07756,0.21498 0.48637,0.12623 0.9519,0.32752 1.38345,0.59321 0.15328,0.0944 0.15742,0.31124 0.29954,0.41143 0.17109,0.12061 0.35097,0.23876 0.47711,0.41169 0.0623,0.0854 0.0168,0.22331 -0.0967,0.23431 -0.23449,0.0227 -0.45664,-0.10445 -0.69346,-0.0707 -0.30829,0.044 -0.6101,0.12612 -0.90137,0.23342 -0.0833,0.0307 -0.26093,0.0301 -0.24224,0.12679 0.0157,0.0814 0.0867,0.14275 0.15288,0.18691 0.17858,0.11913 0.38561,0.18064 0.57027,0.2917 0.27985,0.16831 0.56333,0.33411 0.80935,0.55177 0.32556,0.28803 0.64332,0.58853 0.91726,0.92625 0.1703,0.20995 0.30628,0.45094 0.52926,0.61713 0.10516,0.0784 0.26748,0.11371 0.31493,0.23676 0.031,0.0805 -0.12397,0.0425 -0.17131,0.0423 -0.83687,-0.004 -1.68164,-0.0985 -2.51216,0.0467 -0.49759,0.087 -0.99278,0.23995 -1.41984,0.51002 -0.31197,0.19729 -0.49751,0.55582 -0.81673,0.73478 -0.065,0.0364 -0.0885,0.20292 -0.12981,0.16421 -0.11393,-0.10677 -0.13538,-0.27395 -0.25831,-0.37851 -0.41211,-0.35054 -0.84516,-0.6771 -1.29606,-0.97565 -0.30609,-0.20267 -0.60727,-0.42628 -0.9539,-0.55172 -0.0679,-0.0246 -0.24937,-0.0986 -0.21436,0.0382 0.0561,0.2192 0.16781,0.41901 0.25277,0.62764 0.0825,0.20251 0.16006,0.40881 0.20092,0.62677 0.0243,0.12979 -0.10987,0.16021 -0.21666,0.13875 -0.35391,-0.0711 -0.68148,-0.23002 -1.00941,-0.37521 -0.45153,-0.19991 -0.89794,-0.4316 -1.38479,-0.5294 -0.1803,-0.0362 -0.40791,-0.12835 -0.55107,-0.008 -0.0989,0.0828 -0.15215,0.20608 -0.21161,0.31797 -0.14862,0.27968 -0.14252,0.74639 -0.4462,0.83924 -0.0824,0.0252 -0.18388,-0.069 -0.25813,-0.11609 -0.52782,-0.3344 -1.04913,-0.68261 -1.53265,-1.07835 -0.1615,-0.13218 -0.35207,-0.24423 -0.46361,-0.42202 -0.0126,-0.0201 -0.0315,-0.0433 -0.0259,-0.0688",
    id: "path2776"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 169.49392,128.53676 c 0.91348,-0.14405 1.847,-0.007 2.75894,-0.16362 0.36628,-0.0629 0.71999,-0.18045 1.07655,-0.28236 0.6335,-0.18106 1.27535,-0.36352 1.93632,-0.39708 0.37852,-0.0192 0.77612,0.007 1.11748,0.18738 0.31452,0.16594 0.53881,0.49125 0.58072,0.84615 0.022,0.18613 0.0332,0.37281 0.0581,0.55913 0.0675,0.50499 -0.008,1.03826 -0.26231,1.48463 -0.18064,0.31767 -0.47061,0.58005 -0.82132,0.69237 -0.14894,0.0477 -0.3061,0.0865 -0.46264,0.0746 -0.31968,-0.0243 -0.63631,-0.0846 -0.94551,-0.16764 -0.33801,-0.0908 -0.68092,-0.19441 -0.97503,-0.38827 -0.14534,-0.0958 -0.29414,-0.2202 -0.33731,-0.39618 -0.0427,-0.17394 0.0428,-0.37529 0.20838,-0.45231 0.17792,-0.0828 0.38433,-0.0651 0.56964,-0.0188 0.14616,0.0365 0.2817,0.10692 0.40016,0.20081 0.26241,0.20799 0.42997,0.51394 0.51755,0.83325 0.13153,0.47956 0.14891,0.98228 0.12171,1.47444 -0.0205,0.37153 -0.0168,0.74989 -0.12844,1.10913 -0.0806,0.25923 -0.19223,0.50983 -0.33628,0.73924 -0.22959,0.36565 -0.6087,0.61823 -1.01359,0.7513 -0.33933,0.11152 -0.71252,0.1572 -1.0611,0.0635 -0.17622,-0.0474 -0.34602,-0.13687 -0.4635,-0.2794",
    id: "path2780"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 164.87084,124.41937 c 0.21821,-0.42226 0.57353,-0.76915 0.99875,-0.98194 0.55136,-0.27592 1.1757,-0.3543 1.78446,-0.37724 0.63901,-0.0241 1.27826,0.002 1.91758,-0.0108 0.55287,-0.0112 1.1126,-0.0453 1.65864,0.0536 0.49167,0.0891 0.91117,0.38311 1.39363,0.50572 0.52061,0.13231 1.0657,0.16904 1.57149,0.3548 0.36879,0.13544 0.70504,0.3494 1.08579,0.45572 0.35316,0.0986 0.71591,0.16302 1.05945,0.29643 0.88843,0.34501 1.67817,0.9012 2.57293,1.23118 0.0485,0.0179 0.0973,0.035 0.14632,0.0514",
    id: "path2784"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 191.19534,128.93921 c 0.59949,-0.37489 1.17857,-0.79783 1.64411,-1.33546 0.22606,-0.26107 0.5328,-0.49668 0.6158,-0.83158 0.19265,-0.77733 0.35985,-1.57393 0.32744,-2.37849 -0.0195,-0.48461 -0.11723,-0.98804 -0.40816,-1.38824 -0.20023,-0.27544 -0.50497,-0.45292 -0.82561,-0.56 -0.60739,-0.20285 -1.21718,-0.45133 -1.86217,-0.47732 -0.45566,-0.0184 -0.89811,0.13691 -1.30315,0.33117 -0.66888,0.3208 -1.24932,0.79004 -1.86096,1.20482 -0.65196,0.44212 -1.24835,0.95887 -1.82986,1.48854 -0.56355,0.51331 -1.14006,1.01934 -1.78707,1.425 -0.2039,0.12784 -0.40343,0.26611 -0.62899,0.35519 -0.60994,0.24089 -1.29168,0.23086 -1.92382,0.0837 -0.33616,-0.0782 -0.65528,-0.21191 -0.97275,-0.34548 -0.45045,-0.18952 -0.89605,-0.39355 -1.35922,-0.54978 -0.1013,-0.0342 0.009,0.0237 0.0389,0.0366",
    id: "path2796"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 193.98154,125.53385 c 0.13672,0.0888 0.29143,0.15167 0.41525,0.25831 0.11855,0.1021 0.15559,0.26158 0.19821,0.40475 0.0856,0.28759 0.17654,0.57463 0.21723,0.87342 0.0862,0.63267 -0.0338,1.2793 -0.27525,1.86619 -0.32484,0.78946 -0.92173,1.42283 -1.36517,2.14586 -0.22497,0.36682 -0.41934,0.75718 -0.69503,1.08821 -0.0446,0.0535 -0.0819,0.18099 -0.14668,0.15122 -0.0551,-0.0253 -0.0415,-0.12295 -0.0442,-0.17829 -0.0209,-0.43903 -0.008,-0.87878 -0.006,-1.3181 5.8e-4,-0.19345 0.18823,-0.62906 9.7e-4,-0.58044 -0.0579,0.015 -0.098,0.10835 -0.13174,0.16433 -0.0979,0.1626 -0.14912,0.36076 -0.28642,0.49205 -0.0742,0.071 -0.14138,0.14929 -0.19616,0.23698 -0.0757,0.12116 -0.14533,0.25141 -0.26629,0.33651 -0.1166,0.082 -0.24616,0.1489 -0.33923,0.26105 -0.11793,0.14211 -0.21308,0.30442 -0.3646,0.41798 -0.47772,0.35805 -0.99867,0.65768 -1.46198,1.03418 -0.12708,0.10327 -0.20194,0.25648 -0.33674,0.35349 -0.0752,0.0541 -0.13539,-0.0277 -0.1419,-0.1015 -0.017,-0.19219 0.0224,-0.38385 0.0605,-0.57128 0.0578,-0.28402 0.12885,-0.56511 0.20005,-0.84589 0.0475,-0.18724 0.30391,-0.46278 0.13856,-0.56297 -0.0411,-0.0249 -0.10089,0.0736 -0.13969,0.10587 -0.0685,0.057 -0.15344,0.0897 -0.23121,0.13292 -0.30931,0.17175 -0.59897,0.37916 -0.9269,0.51716 -0.46801,0.19694 -0.97572,0.29057 -1.43122,0.51629 -0.14955,0.0741 -0.30091,0.1471 -0.46455,0.19024 -0.0702,0.0185 -0.13101,-0.0448 -0.1182,-0.1161 0.0249,-0.13866 0.11371,-0.25388 0.19229,-0.36688 0.0765,-0.11005 0.18947,-0.20111 0.23217,-0.32854 0.32304,-0.96413 0.84231,-1.85693 1.12347,-2.83506 0.0192,-0.0669 0.12832,-0.15761 0.0784,-0.20144 -0.13079,-0.11475 -0.27948,-0.20702 -0.42206,-0.30625 -0.25158,-0.17508 -0.54502,-0.30809 -0.74194,-0.54365 -0.035,-0.0418 -0.14792,-0.11248 -0.0941,-0.15208 0.27177,-0.20011 0.61015,-0.27299 0.93563,-0.3318 0.28604,-0.0517 0.5727,-0.1044 0.84935,-0.19716 0.37966,-0.1273 0.73422,-0.34115 1.12942,-0.40858 0.23199,-0.0396 0.46888,-0.0347 0.70232,-0.0616 0.14623,-0.0168 0.29573,-0.0321 0.43379,-0.0892 0.074,-0.0306 0.0465,-0.12181 0.0376,-0.18211 -0.0566,-0.38379 -0.18966,-0.75926 -0.19037,-1.14818 -1.3e-4,-0.071 -0.0272,-0.16919 0.0339,-0.21282 0.0769,-0.0549 0.17434,-0.0701 0.26524,-0.0864 0.45064,-0.081 0.90784,-0.11833 1.36404,-0.15101 0.67763,-0.0485 1.35611,-0.0951 2.03552,-0.10281 0.0167,-1.9e-4 0.0334,-3.2e-4 0.0501,-3.2e-4",
    id: "path2800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da44af7df15b37ead95be9c9c42b02c4.svg";
export { ForwardRef as ReactComponent };